import type { INDENTS } from 'vars/indents'

import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const SearchLoaderSC = styled.div<{
  paddings?: INDENTS[] | FIXED_INDENTS[]
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(${FIXED_INDENTS.INDENT_60});

  ${MEDIA.MIN_600} {
    flex-direction: row;
    gap: var(${FIXED_INDENTS.INDENT_40});
  }

  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
`
